import React, { useState, useEffect } from 'react'
import { DataTable, Button } from '@paypalcorp/pp-react'
import { TextInputWrapper } from '../components/pp-react-wrappers'
import Fuse from 'fuse.js'

const CodeCell = (value) => {
  return <code>{value.value}</code>
}

const allRows = [
  {
    id: 'row1',
    name: {
      value: 'visa',
    },
    value: {
      value: 'Visa',
    },
  },
  {
    id: 'row2',
    name: {
      value: 'mastercard',
    },
    value: {
      value: 'Mastercard',
    },
  },
  {
    id: 'row3',
    name: {
      value: 'amex',
    },
    value: {
      value: 'American Express',
    },
  },
  {
    id: 'row4',
    name: {
      value: 'discover',
    },
    value: {
      value: 'Discover',
    },
  },
  {
    id: 'row5',
    name: {
      value: 'jcb',
    },
    value: {
      value: 'JCB',
    },
  },
  {
    id: 'row6',
    name: {
      value: 'elo',
    },
    value: {
      value: 'Elo',
    },
  },
  {
    id: 'row7',
    name: {
      value: 'hiper',
    },
    value: {
      value: 'Hiper',
    },
  },
]

const columns = {
  name: {
    title: 'Option',
    width: '50%',
    cellAs: CodeCell,
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  value: {
    title: 'Description',
    mobile: {
      placement: 'b3',
    },
  },
}

const options = {
  threshold: 0.4,
  keys: ['name.value', 'value.value'],
}

const fuse = new Fuse(allRows, options)

const PaymentTypesTable = () => {
  const [rows, setRows] = useState(allRows.slice(0, 5))
  const [isLoading, setLoading] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const showSeeMoreBtn = rows.length < allRows.length
  const [filteredRows, setFilteredRows] = useState([])

  useEffect(() => {
    if (searchInput) {
      setFilteredRows(fuse.search(searchInput).map(({ item }) => item))
    } else {
      setFilteredRows([])
    }
  }, [searchInput])

  const handleTextChange = (e) => {
    setSearchInput(e.target.value)
  }

  const handleSeeMore = () => {
    setSearchInput('')
    setLoading(true)
    setTimeout(() => {
      setRows((currRowsShown) => allRows.slice(0, currRowsShown.length + 5))
      setLoading(false)
    }, 300)
  }

  return (
    <>
      <TextInputWrapper
        nameValue="basic"
        errorPresent={false}
        errorTextForFpti=""
        name="basic"
        value={searchInput}
        label="Search table"
        labelClassName="test"
        onKeyUp={handleTextChange}
      />
      <DataTable
        description="Basic"
        rows={searchInput ? filteredRows : rows}
        columns={columns}
        isLoading={isLoading}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
      {showSeeMoreBtn && (
        <div className="table-btnWrapper">
          <Button onClick={handleSeeMore} size="sm" secondary>
            See more
          </Button>
        </div>
      )}
    </>
  )
}

export default PaymentTypesTable
